



























import _ from "underscore";
import { Component, Vue } from "vue-property-decorator";

import BreadcrumbList, {
  BreadcrumbData,
} from "@/components/common/breadcrumb/BreadcrumbList.vue";
import EventArea from "@/components/event/EventArea.vue";
import EventList from "@/components/event/EventList.vue";
import EventServiceName from "@/components/event/EventServiceName.vue";
import EventTabs from "@/components/event/EventTabs.vue";
import FlexibleContentArea from "@/components/layout/FlexibleContentArea.vue";
import SiteSimpleImageArea from "@/components/layout/SiteSimpleImageArea.vue";
import ServiceCategoryTab from "@/components/service/ServiceCategoryTab.vue";
import { API_ERROR_MESSAGE, CurrentFlag } from "@/consts/const";
import { RouteName } from "@/consts/route";
import { ApiNetworkError } from "@/errors/api/api-network-error";
import { ApiResponseNotFoundError } from "@/errors/api/api-response-not-found-error";
import { ServiceMenuAndEventsResponseInterface } from "@/interfaces/api/service-menu-and-events-response.interface";
import { ServiceInterface } from "@/interfaces/service.interface";
import { ServiceCategoryInterface } from "@/interfaces/service-category.interface";
import { ServiceMenuInterface } from "@/interfaces/service-menu.interface";
import { ServiceMenuEventInterface } from "@/interfaces/service-menu-event.interface";
import { ViewUtil } from "@/utils/view.util";

@Component({
  components: {
    EventList,
    EventTabs,
    EventArea,
    EventServiceName,
    FlexibleContentArea,
    ServiceCategoryTab,
    SiteSimpleImageArea,
    BreadcrumbList,
  },
})
export default class EventPage extends Vue {
  private categories: ServiceCategoryInterface[] = [];
  private category: ServiceCategoryInterface | null = null;
  private service: ServiceInterface | null = null;
  private serviceMenu: ServiceMenuInterface | null = null;
  private currentEvents: ServiceMenuEventInterface[] = [];
  private closedEvents: ServiceMenuEventInterface[] = [];

  async mounted(): Promise<void> {
    this.showLoading();
    ViewUtil.scrollToTop();

    try {
      if (!(await this.setUpCategory()) || !(await this.setUpServiceMenu())) {
        this.$router.push({ name: RouteName.NotFound });
      }
    } catch (e) {
      if (e instanceof ApiNetworkError) {
        this.errorToast(this.$t(API_ERROR_MESSAGE.FAILED_GENERAL).toString());
      } else if (e instanceof ApiResponseNotFoundError) {
        this.$router.push({ name: RouteName.NotFound });
      } else {
        this.errorToast(this.$t(API_ERROR_MESSAGE.FAILED_TO_GET).toString());
      }
    } finally {
      this.hideLoading();
    }
  }

  private async setUpCategory(): Promise<boolean> {
    const categories = await this.$service.getCategories(this);
    const category = this.$service.getCategoryByRouteKey(
      categories,
      this.$route.params.key
    );

    if (!category) {
      return false;
    }

    this.categories = categories;
    this.category = category;

    return true;
  }

  private async setUpServiceMenu(): Promise<boolean> {
    const serviceMenuId = Number(this.$route.params.serviceMenuId);

    if (_.isNaN(serviceMenuId)) {
      return false;
    }

    const data: ServiceMenuAndEventsResponseInterface =
      await this.$api.getServiceMenuAndEvents(serviceMenuId);

    this.service = data.service;
    this.serviceMenu = data.serviceMenu;
    this.currentEvents = data.events.filter(
      (event: ServiceMenuEventInterface) => event.currentFlag === CurrentFlag.On
    );
    this.closedEvents = data.events.filter(
      (event: ServiceMenuEventInterface) =>
        event.currentFlag === CurrentFlag.Off
    );

    return true;
  }

  private get breadcrumbs(): BreadcrumbData[] {
    const items: BreadcrumbData[] = [{ name: "Home", route: RouteName.Home }];

    if (!this.category) {
      return items;
    }

    items.push({
      name: this.category.name,
      route: RouteName.Service,
      params: { key: this.category.routeKey },
    });

    if (!this.service || !this.serviceMenu) {
      items.push({
        name: this.$t("message.EventPage.status").toString(),
        route: RouteName.ServiceStatus,
        params: { key: this.category.routeKey },
      });
    } else {
      items.push({
        name: this.$t("message.EventPage.status").toString(),
        route: RouteName.ServiceStatus,
        params: { key: this.category.routeKey },
        hash: `#service-${this.service.id}`,
      });
      items.push({
        name: this.serviceMenu.name,
      });
    }

    return items;
  }

  private get categoryId(): number {
    if (!this.category) {
      return 0;
    }

    return this.category.id;
  }

  private onClickTab(category: ServiceCategoryInterface): void {
    this.category = category;
    this.$router.push({
      name: RouteName.Service,
      params: { key: category.routeKey },
    });
  }

  private onClickEvent(event: ServiceMenuEventInterface): void {
    if (!this.category || !this.serviceMenu) {
      return;
    }

    this.$router.push({
      name: RouteName.EventDetail,
      params: {
        key: this.category.routeKey,
        serviceMenuId: `${this.serviceMenu.id}`,
        eventId: event.id,
      },
    });
  }
}
